import { BriefingPanel } from "@/features/briefing/BriefingPanel";

/**
 * Inline chat result-card: the live Briefing (Schedule / Tasks / Watchlist).
 * Self-contained — `BriefingPanel` fetches its own data via `useBriefingData`,
 * so the card payload carries none. Triggered by the agent's briefing tool when
 * the user asks "give me a briefing" / "what's on my plate".
 */
export function BriefingResultCard({
  data,
  onOpenEvent,
}: {
  /** Card payload from the agent's today_card tool: { horizon?: 'today'|'10'|'30'|'90' }. */
  data?: Record<string, unknown>;
  onOpenEvent?: (id: string, start?: string | null) => void;
}) {
  const h = String((data as { horizon?: unknown } | undefined)?.horizon ?? "today");
  const initialHorizon = h === "10" ? 10 : h === "30" ? 30 : h === "90" ? 90 : 0;
  // In chat: schedule + tasks only (watchlist is its own surface), no refresh.
  return (
    <BriefingPanel
      showRefresh={false}
      showWatchlist={false}
      onOpenEvent={onOpenEvent}
      initialHorizon={initialHorizon}
    />
  );
}

export default BriefingResultCard;
